(function () {
    'use strict';

    var module = angular.module('uwAgenda.settings.agendasettings');
    module.controller('AgendaSettingsExtraDayHolidayTypeController', ['$scope', '$stateParams', '$state', 'WebsocketService', 'WebsocketRegisterType', 'days', 'globalholidays', 'agendaId', AgendaSettingsExtraDayHolidayTypeControllerFn]);

    /* controlle for main extra days and holidays */
    function AgendaSettingsExtraDayHolidayTypeControllerFn($scope, $stateParams, $state, WebsocketService, WebsocketRegisterType, days, globalholidays, agendaId) {
        var vm = this;

        // label breadcrumb
        vm.label = '';
        vm.days = [];
        
        activate();

        /* activation work */
        function activate() {
            // days
            vm.days = days;
            vm.agendaId = agendaId;
            // add global holidays to day-list
            if (typeof globalholidays !== 'undefined') {
                for (var i = 0; i < globalholidays.length; i++) {
                    vm.days.push(globalholidays[i]);
                } //for
            } //if


            if ($stateParams.readonly === false) {
                vm.label = 'additional_times';
            }//if
            else {
                vm.label = 'blocking_times';
            } //else


            // listen
            listen();
        } // activate

        // listen for websocket events
        function listen() {

           // Websocket Listen
           var ws = WebsocketService.register(WebsocketRegisterType.Agenda, function (jObject) {
               // refresh only if correct agenda
               if (jObject.data.fK_Agenda === vm.agendaId) {
                   $state.go($state.current, $stateParams, { reload: $state.current });
               }
               
           });

           // on destroy
           $scope.$on("$destroy", function () {
               if (ws) { WebsocketService.unregister(ws.id); }
           });
        }


    }
})();
